import { AbstractControlOptions, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { Directive } from '@angular/core';

@Directive()
export abstract class EaSimulationPinelFormBuilder extends PrFormAbstract {
  generate(entity: any) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        amount: [entity ? entity.amount : null, Validators.required],
        cashPercentage: [
          entity ? entity.cashPercentage : null,
          Validators.required,
        ],
        loanDuration: [
          entity ? entity.loanDuration : null,
          Validators.required,
        ],
        loanRate: [entity ? entity.loanRate : null, Validators.required],
        rentalReportPercentage: [
          entity ? entity.rentalReportPercentage : null,
          Validators.required,
        ],
        bankingFees: [entity ? entity.bankingFees : null, Validators.required],
        notaryFeesPercentage: [
          entity ? entity.notaryFeesPercentage : null,
          Validators.required,
        ],
        rentalCommitmentInYears: [
          entity ? entity.rentalCommitmentInYears : null,
          Validators.required,
        ],
        estateTaxPercentage: [
          entity ? entity.estateTaxPercentage : null,
          Validators.required,
        ],
        propertyRevaluation: [
          entity ? entity.propertyRevaluation : null,
          Validators.required,
        ],
        rentalRevaluation: [
          entity ? entity.rentalRevaluation : null,
          Validators.required,
        ],
        managementFeesPercentage: [
          entity ? entity.managementFeesPercentage : null,
          Validators.required,
        ],
        coOwnershipFeesPercentage: [
          entity ? entity.coOwnershipFeesPercentage : null,
          Validators.required,
        ],
        simulationDurationInYears: [
          entity ? entity.simulationDurationInYears : null,
          Validators.required,
        ],
        areaSize: [entity ? entity.areaSize : null],
      },
      options,
    );
  }

  extract() {
    let dto: any = {
      amount: this.emptyIsNull(this.form.value.amount),
      cashPercentage: this.emptyIsNull(this.form.value.cashPercentage),
      loanDuration: this.emptyIsNull(this.form.value.loanDuration),
      loanRate: this.emptyIsNull(this.form.value.loanRate),
      rentalReportPercentage: this.emptyIsNull(
        this.form.value.rentalReportPercentage,
      ),
      bankingFees: this.emptyIsNull(this.form.value.bankingFees),
      notaryFeesPercentage: this.emptyIsNull(
        this.form.value.notaryFeesPercentage,
      ),
      rentalCommitmentInYears: this.emptyIsNull(
        this.form.value.rentalCommitmentInYears,
      ),
      estateTaxPercentage: this.emptyIsNull(
        this.form.value.estateTaxPercentage,
      ),
      propertyRevaluation: this.emptyIsNull(
        this.form.value.propertyRevaluation,
      ),
      rentalRevaluation: this.emptyIsNull(this.form.value.rentalRevaluation),
      managementFeesPercentage: this.emptyIsNull(
        this.form.value.managementFeesPercentage,
      ),
      coOwnershipFeesPercentage: this.emptyIsNull(
        this.form.value.coOwnershipFeesPercentage,
      ),
      simulationDurationInYears: this.emptyIsNull(
        this.form.value.simulationDurationInYears,
      ),
      areaSize: this.emptyIsNull(this.form.value.areaSize),
    };
    return dto;
  }
}
